// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `S.locatorList_yS88v {
    font-weight: 700;
    margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/r4k/views/ConvertLocatorToGateway.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,gBAAgB;AACpB","sourcesContent":["S.locatorList {\n    font-weight: 700;\n    margin-top: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"locatorList": `locatorList_yS88v`
};
export default ___CSS_LOADER_EXPORT___;
